//====================================================
//  Function: Success
//====================================================
function componentSuccess() {
  // BASKET IN KOSIK
  if ($(".reca-number").length) {
    var recaNumber = $(".reca-number strong").text();

    var succesBox = `<div class="reca-box">
		<div class="reca-top-block">
			<div class="reca-top__icon">
				<svg class="icon-svg icon-tree-package">
					<use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-tree-package"></use>
				</svg>
			</div>
			<div class="reca-top__title"> ${basketSuccessTitle} </div>
		</div>
		<div class="reca-bottom-block p--margin-0">
			<p>${basketSuccessText} <span>${recaNumber}</span> ${basketSuccessText2}</p>
		</div>
	</div>`;

    $(".content-inner").append(succesBox);

    $(".content-inner").prepend('<div class="content-header"></div>');

    var basketComplete = `<ol class="cart-header step-0">
					<li class="step step-1 completed"><strong><span>${basketSuccessHeaderStep1}</span></strong></li>
					<li class="step step-2 completed"><strong><span>${basketSuccessHeaderStep2}</span></strong></li>
					<li class="step step-3 completed"><strong><span>${basketSuccessHeaderStep3}</span></strong></li>
					<li class="step step-4 completed"><strong><span>${basketSuccessHeaderStep4}</span></strong></li>
        </ol>
		`;

    $(".content-header").append(basketComplete);
  }
}

function cartHeaderAddStep() {
  var successStep = `<li class="step step-4">
                        <strong><span>${basketSuccessHeaderStep4}</span></strong>
										</li>`;
  $(".cart-header").append(successStep);
}
